import React from "react";

import styles from "../ProfilePage.module.scss";

interface UsageSummaryCardProps {
  label: string;
  value: string;
}

const UsageSummaryCard: React.FC<UsageSummaryCardProps> = ({
  label,
  value,
}) => (
  <div className={styles.developerUsageSummaryCard}>
    <span className={styles.developerUsageSummaryLabel}>{label}</span>
    <span className={styles.developerUsageSummaryValue}>{value}</span>
  </div>
);

export default UsageSummaryCard;
